import ajax from './ajax'

//用户相关
export const reqLogin = (email, password) => ajax('/api/login', {email, password}, 'POST')
export const reqSave = (name, partner_type) => ajax('/api/save', {name, partner_type}, 'POST')
export const reqUserDetail = () => ajax('/api/details', {}, 'GET')
export const reqRegister = (user_info) => ajax('/api/register', user_info, 'POST')
export const reqResetPassword = (email, token, password, password_confirmation) => ajax('/api/password/reset', {email, token, password, password_confirmation}, 'POST')
export const reqSendResetPasswordEmail = (email) => ajax('/api/password/email', {email}, 'POST')

//配置相关
export const reqCountry = () => ajax('/api/country', {}, 'GET')
export const reqPartnerType = () => ajax('/api/partnerType', {}, 'GET')
export const reqAppList = () => ajax('/api/appList', {}, 'GET')

//转化相关
export const reqConversionsInfo = () => ajax('/api/conversionsInfo', {}, 'POST')
export const reqConversionsList = (offset, order) => ajax('/api/conversionsList', {offset, order}, 'POST')
export const reqPaymentDetail = (offset, order) => ajax('/api/paymentDetail', {offset, order}, 'POST')





